import TextField from '@mui/material/TextField';
import styled from 'styled-components';

type InputProps = {
    $inputSize: 's' | 'm';
    $isMultiline: boolean;
    $helperTextStatic?: boolean;
};

export const Input = styled(TextField)<InputProps>`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;

    .MuiInputAdornment-root {
        ${(props) => props.theme.typography.smallTextBold};
    }

    .MuiInputBase-root {
        background-color: ${(props) => props.theme.palette.primaryA6};
        border-color: ${(props) => props.theme.palette.primaryA4};
        color: ${(props) => props.theme.palette.textMain};
        letter-spacing: 0.002em;
        border-radius: 8px;
        min-height: 52px;

        ${(props) => props.theme.typography.smallTextBold};

        ${(props) => {
            switch (props.$inputSize) {
                // border 1px and box-sizing: border-box, decreese padding by 1px
                case 's':
                    if (props.$isMultiline) {
                        return {
                            padding: '7px 12px',
                        };
                    }

                    return {
                        padding: '7px 12px',
                        minHeight: 32,
                        maxHeight: 32,
                    };
                case 'm':
                    if (props.$isMultiline) {
                        return {
                            padding: '13px 12px',
                        };
                    }

                    return {
                        padding: '13px 12px',
                        minHeight: 44,
                        maxHeight: 44,
                    };

                default:
                    if (props.$isMultiline) {
                        return {
                            padding: '13px 12px',
                        };
                    }

                    return {
                        padding: '13px 12px',
                        minHeight: 44,
                        maxHeight: 44,
                    };
            }
        }};

        input {
            padding: 0;
            ${(props) => props.theme.typography.smallTextBold};
        }

        .MuiInputBase-input {
            height: 16px;

            &.Mui-disabled {
                cursor: default;
            }
        }

        .MuiBox-root {
            //in case when svg inside fox Mui box
            svg {
                color: unset;
            }
        }

        svg {
            color: ${(props) => props.theme.palette.textLight};
        }

        &.Mui-focused {
            border: 1px solid ${(props) => props.theme.palette.primaryA1};
        }

        input::placeholder {
            font-family: 'Mont', sans-serif;
            color: ${(props) => props.theme.palette.textLight};
            opacity: 1;
        }
    }

    .MuiInputAdornment-positionEnd {
        margin-right: 5.5px;
    }

    .MuiFormHelperText-root {
        ${(props) => {
            if (!props.$helperTextStatic) {
                return {
                    position: 'absolute',
                    left: 0,
                    width: 'max-content',
                    bottom: '-20px',
                };
            }

            return {
                alignSelf: 'start',
            };
        }}
        ${(props) => props.theme.typography.smallTextBold}
        color: ${(props) => props.theme.palette.secondaryA4};
    }

    .MuiFormLabel-root.Mui-error {
        color: ${(props) => props.theme.palette.secondaryA4};
    }

    &.Mui-error-container {
        .MuiInputBase-root {
            border-color: ${(props) => props.theme.palette.secondaryA4};
            svg {
                color: ${(props) => props.theme.palette.secondaryA4};
            }
        }
    }

    .helper-container {
        display: flex;
        flex-direction: column;
        gap: 2px;

        .hint {
            ${(props) => props.theme.typography.smallTextBold}
            color: ${(props) => props.theme.palette.textLight};
        }
    }
`;
